<script lang="ts">
    import CodeInput from "$lib/elements/CodeInput.svelte";

    let totpCode = "";
    let isValid = false;

    function handleOTPChange(event: any) {
        totpCode = event.detail.otpCode;
        isValid = event.detail.isValid;
    }


</script>

<div>
<CodeInput on:change={handleOTPChange} />


</div>